exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blog-title{margin-top:0}.label.active{background-color:#03a9f4}.panel-footer{background-color:#fff}.blog-pinned>.panel-heading>.panel-title>.heading-elements-toggle{display:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-99c234d4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/blog/BlogMain.vue
// module id = 270
// module chunks = 0